import { ReactChild } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { darkTheme } from 'design-system/theme';

export enum DashboardDocumentHeaderPosition {
  Start = 'start',
  Center = 'center',
  End = 'end',
}

interface DashboardDocumentHeaderProps {
  children: ReactChild;
}

const DocumentViewerHeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;

  max-height: 72px;
  width: 100%;

  padding: 20px 20px;
  color: ${({ theme }) => theme.color.text.primary};
  background-color: ${({ theme }) => theme.color.background.primary};
`;

const DocumentViewerHeader = ({ children }: DashboardDocumentHeaderProps) => {
  return (
    <ThemeProvider theme={darkTheme}>
      <DocumentViewerHeaderContainer data-test='document-viewer__header'>
        {children}
      </DocumentViewerHeaderContainer>
    </ThemeProvider>
  );
};

export default DocumentViewerHeader;
